const erroLoginTypes = {
    SemPerfilDisponivel: 1,
}

export default erroLoginTypes;